import type { User } from '../types';
import { apiClient } from './client';

export interface LoginResponse {
  accessToken: string;
  refreshToken?: string;
  user: User;
}

export interface SwitchOrgResponse {
  accessToken: string;
  refreshToken?: string;
  user: User;
}

export interface RefreshResponse {
  accessToken: string;
}

export const auth = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const { data } = await apiClient.post<LoginResponse>('/api/auth/login', { email, password });
    return data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/api/auth/logout');
  },

  me: async (): Promise<User> => {
    const { data } = await apiClient.get<User>('/api/auth/me');
    return data;
  },

  refresh: async (): Promise<RefreshResponse> => {
    const { data } = await apiClient.post<RefreshResponse>('/api/auth/refresh', {});
    return data;
  },

  switchOrg: async (targetOrgSlug: string): Promise<SwitchOrgResponse> => {
    const { data } = await apiClient.post<SwitchOrgResponse>('/api/auth/switch-org', { targetOrgSlug });
    return data;
  },

  acceptInvite: async (token: string): Promise<void> => {
    await apiClient.post('/api/auth/accept-invite', { token });
  },
};
